export default {
  ADDRESS_POLITICAL_DIVISIONS: [
    { name: 'país' },
    { name: 'departamento' },
    { name: 'provincia' },
    { name: 'distrito' },
  ],

  CURRENCIES: [
    { title: 'Soles', value: 1 },
  ],

  INSURANCE_TYPES: [
    { text: 'Mancomunado', value: 1 },
    { text: 'Individual', value: 2 },
    { text: 'Endosado', value: 3 },
  ],

  VAT_TYPES: [
    { text: 'DNI', value: 1 },
    { text: 'Carnet de Extranjería', value: 2 },
  ],

  /* Flow */
  STEPS: () => require('./steps').default,
};
